import React, { Component } from 'react';
import Amplify from 'aws-amplify';
import { AmplifyTheme, Authenticator, SignUp } from 'aws-amplify-react';
import App from './App';
import configProd from './config';
import PageViewContainer from './containers/PageViewContainer';

const noNavBar = { ...AmplifyTheme.nav, display: 'none' };

const MyTheme = {
  ...AmplifyTheme,
  nav: noNavBar,
  container: { ...AmplifyTheme.container, padding: '0' },
};

Amplify.configure({
  API: {
    endpoints: [
      {
        name: 'CMS',
        endpoint:
          process.env.REACT_APP_API_GATEWAY_URL || configProd.apiGateway.URL,
        region:
          process.env.REACT_APP_API_GATEWAY_REGION ||
          configProd.apiGateway.REGION,
        service: 'execute-api',
      },
    ],
    aws_appsync_graphqlEndpoint:
      process.env.REACT_APP_APPSYNC_ENDPOINT || configProd.appsync.ENDPOINT,
    aws_appsync_region:
      process.env.REACT_APP_APPSYNC_REGION || configProd.appsync.REGION,
    aws_appsync_authenticationType: 'AWS_IAM',
    aws_appsync_apiKey:
      process.env.REACT_APP_APPSYNC_API_KEY || configProd.appsync.API_KEY,
  },
  Auth: {
    identityPoolId:
      process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID ||
      configProd.cognito.IDENTITY_POOL_ID,
    region: process.env.REACT_APP_COGNITO_REGION || configProd.cognito.REGION,
    userPoolId:
      process.env.REACT_APP_COGNITO_USER_POOL_ID ||
      configProd.cognito.USER_POOL_ID,
    userPoolWebClientId:
      process.env.REACT_APP_COGNITO_APP_CLIENT_ID ||
      configProd.cognito.APP_CLIENT_ID,
    mandatorySignIn: true,
  },
  Analytics: {
    disabled: true,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.BUCKET || configProd.AWSS3.BUCKET,
      region: process.env.REGION || configProd.AWSS3.REGION,
    },
  },
});

// TODO: refactor component to prevent `react/prefer-stateless-function` ESlint error
// eslint-disable-next-line react/prefer-stateless-function
class AppWithAuth extends Component {
  render() {
    return (
      <div style={{ height: '100vh', width: '100vw' }}>
        <Authenticator theme={MyTheme} hide={[SignUp]}>
          <App />
        </Authenticator>
      </div>
    );
  }
}

export default AppWithAuth;
